module.exports = __webpack_public_path__ + "static/media/06.daa2a906.svg";